<script setup>
    import { ref } from "vue";
    import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
    import { Link, Head } from '@inertiajs/inertia-vue3';
    import BaseButton from "@/Components/BaseButton.vue";
    import { mdiPlusCircle } from "@mdi/js";
    import CardBox from "@/Components/CardBox.vue";
    import TableAdvancedFilter from "@/Components/TableAdvancedFilter.vue";
    import CardBoxComponentEmpty from '@/Components/CardBoxComponentEmpty.vue';

    defineProps({
        curriculas: Array,
        columnas: Array,
        curriculadets: Array,
        columnadets: Array
    });

    const rutaPrefijo = ref('curricula');
    const modulo = ref('Curricula');
    const modulos = ref('Plan Curricular');// Curriculas
    const tab = ref(0);
</script>

<template>
    <Head title="Plan curricular" />

    <BreezeAuthenticatedLayout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
               <!-- In basebutton: @click="route('dashboard')"-->
                <button @click="(tab=0)" class="relative border-2 lg:border-b-0 lg:border-t lg:border-l lg:border-r inline-block py-2 px-4 rounded-lg lg:rounded-none lg:rounded-t-lg mr-2 mb-3 lg:mb-0" :class="[tab==0 ? 'bg-white border-blue-600' : 'border-gray-200 hover:bg-white bg-gray-100']">
                    <span class="text-sm lg:text-lg text-gray-800 leading-tigh font-bold">Plan curricular actual</span>
                </button>
                <button @click="(tab=1)" class="relative border-2 lg:border-b-0 lg:border-t lg:border-l lg:border-r inline-block py-2 px-4 rounded-lg lg:rounded-none lg:rounded-t-lg mr-2 mb-3 lg:mb-0" :class="[tab==1 ? 'bg-white border-blue-600' : 'border-gray-200 hover:bg-white bg-gray-100']">
                    <span class="text-sm lg:text-lg text-gray-800 leading-tigh font-bold">Histórico por nivel</span>
                </button>

                <!--<Link :href="route(rutaPrefijo+'-create')">
                    <BaseButton
                        color="info"
                        :icon="mdiPlusCircle"
                        small
                        label=" Nuevo"
                        class="ml-8 inline-flex cursor-pointer justify-center items-center whitespace-nowrap focus:outline-none transition-colors focus:ring duration-150 border rounded border-blue-600 dark:border-blue-500 ring-blue-300 dark:ring-blue-700 bg-blue-600 dark:bg-blue-500 text-white hover:bg-blue-700 hover:border-blue-700 hover:dark:bg-blue-600 hover:dark:border-blue-600 p-1 float-right"
                    />
                </Link>-->

                <!--<Link :href="route('student-create')">
                    <BaseButton
                        color="info"
                        :icon="mdiPlusCircle"
                        small
                        label=" Nuevo"
                        class="ml-2 inline-flex cursor-pointer justify-center items-center whitespace-nowrap focus:outline-none transition-colors focus:ring duration-150 border rounded border-blue-600 dark:border-blue-500 ring-blue-300 dark:ring-blue-700 bg-blue-600 dark:bg-blue-500 text-white hover:bg-blue-700 hover:border-blue-700 hover:dark:bg-blue-600 hover:dark:border-blue-600 p-1 float-right"
                    />
                </Link>

                <a href="/public/studentcreate" target="_blank">
                    <BaseButton
                        color="info"
                        :icon="mdiPlusCircle"
                        small
                        label=" Registro público"
                        class="inline-flex cursor-pointer justify-center items-center whitespace-nowrap focus:outline-none transition-colors focus:ring duration-150 border rounded border-blue-600 dark:border-blue-500 ring-blue-300 dark:ring-blue-700 bg-blue-600 dark:bg-blue-500 text-white hover:bg-blue-700 hover:border-blue-700 hover:dark:bg-blue-600 hover:dark:border-blue-600 p-1 float-right"
                    />
                </a>-->
            </h2>   
        </template>

        <div class="py-12">
            <div class="container mx-auto sm:px-6 lg:px-8 px-4"><!--max-w-7xl-->
                <div class="bg-white overflow-hidden shadow-sm sm:rounded-lg">
                    <div class="p-6 bg-white border-b border-gray-200">
                        <!--<div v-for="user in users" :key="user.id">
                            <Link :href="`/users/${user.id}`">
                                {{ user.user}}
                            </Link>
                            <div>{{ user.name}}</div>
                        </div>-->
                        <template v-if="(tab == 0)">
                            <CardBox v-if="curriculadets.length" class="mb-6" has-table>
                                <!-- Tablesingle opciones: checkable -->
                                <TableAdvancedFilter :modulo="modulo" :modulos="modulos" :data="curriculadets" :fields="columnadets" :ruta="rutaPrefijo" exporteable />
                            </CardBox>
                            <CardBox v-else>
                                <CardBoxComponentEmpty />
                            </CardBox>
                        </template>
                        <template v-else-if="(tab == 1)">
                            <CardBox v-if="curriculas.length" class="mb-6" has-table>
                                <!-- Tablesingle opciones: checkable -->
                                <TableAdvancedFilter :modulo="modulo" :modulos="modulos" :data="curriculas" :fields="columnas" :ruta="rutaPrefijo" exporteable />
                            </CardBox>
                            <CardBox v-else>
                                <CardBoxComponentEmpty />
                            </CardBox>
                        </template>
                        
                    </div>
                </div>
            </div>
        </div>
    </BreezeAuthenticatedLayout>
</template>
